import Nav from 'scoreboard/components/nav'
import _ from 'lodash'
import $ from 'jquery'
import Initiative from './initiative'
import InitiativeGardener from './initiatives-gardener'
import NewTab from 'scoreboard/components/new-tab'
import permissions from 'scoreboard/components/permissions'
import i18n from 'scoreboard/components/i18n'
import emptyTree from 'scoreboard/components/empty-tree.hbs'
import metadata from 'scoreboard/components/metadata'
import config from 'scoreboard/components/config'
import BusyButton from 'scoreboard/components/busy-button'
import globals from 'scoreboard/components/globals'
import appDisplay from 'scoreboard/components/app-display'
import InitiativeItemImportWizard from 'scoreboard/initiatives/import/initiative-item-import-wizard'
import { isV5 } from 'scoreboard/components/version'

var InitiativesNav = Nav.extend({
	section: 'initiatives',
	folders: false,
	Gardener: InitiativeGardener,
	Model: Initiative,

	events: _.extend({}, Nav.prototype.events, NewTab.events, {
		'click .import': 'onClickImport'
	}),

	_gardener: function() {
		let gardener = Nav.prototype._gardener.apply(this, arguments)
		gardener.options.showColors = true
		return gardener
	},

	isEditable: function(orgId) {
		return permissions.modifyInitiatives(orgId)
	},

	toggleNavTree: function(tree) {
		if (tree) {
			this.toggleTree(true)
		} else {
			this.$el.empty().append(emptyTree({
				sectionIcon: metadata[this.section].sectionIcon,
				noTypeText: i18n.get('initiatives.timeline.noNavigation'),
				noCreateOption: true
			}))
			this.showingTree = false
		}
	},

	// override superclass so that we don't select the newly added node
	_addDomainObject: function(model) {
		if (model.section !== this.section) {
			return
		}

		this.toggleTree(true)
	},

	_defaultTransientLabel: function(attributes) {
		// Grab the initiative type separately so that it is affected
		// by terminology changes (substitutions are ignored by
		// configurable terminology) #59485
		let initiativeType = i18n.get('initiatives.type.' + attributes.type)
		return i18n.get('common.new2', initiativeType)
	},

	saveTransient: function(relativeId, model, nextModel) {
		Nav.prototype.saveTransient.apply(this, arguments)
		// after adding an initiative node, immediately show another transient
		// in the tree.  Can't do this in _addDomainObject because we need the
		// relativeId.  Wrap in process.nextTick so the gardener has a chance
		// to record the most recently added position
		process.nextTick(function() {
			this.addTransient(relativeId, nextModel)
		}.bind(this))
	},

	_emptyTree: function(options = {}) {
		let buttonClass = isV5() ? 'button-dark' : 'button-default'
		Nav.prototype._emptyTree.apply(this, arguments)
		// #29428 add import initiative items button
		if (options.noCreateOption !== 'false') {
			this.$('.empty-tree').append(
				`<button class="button ${buttonClass} import">
					${i18n.get('initiatives.importInitiativeItems')}
				</button>`
			)
			this._importButton = new BusyButton({el: this.$('.import')})
			// #30386 update the "create" message for more than 1 button
			let msg = i18n.get('common.missing.domainObject.2.multipleButtons')
			this.$('.create').text(msg)
		}

	},

	onClickImport: function() {
		appDisplay.dialog($.get('api/imports/import-data', { statuses: true }), data => {
			let wizard = new InitiativeItemImportWizard()
			wizard.initialize({
				organizationId: globals.orgId,
				connections: data.connections
			})

			wizard.once('done', () => {
				appDisplay.navView().gardener._onceTreeRendered(() => {
					let tree = appDisplay.navView().gardener.tree
					if (tree.get()) {
						tree.select(tree.get().id, {
							toggleOnSelect: false,
							animate: false
						})
					}
				})
			})
			return wizard._view()
		})
	}

})

_.extend(InitiativesNav.prototype, _.omit(NewTab, 'events'))

export default InitiativesNav

InitiativesNav.__filename__ = 'initiatives/initiatives-nav.js'
